// ============================================================================
// Maison — global theme JS
// ============================================================================
// Loaded with `defer` at the end of <body>.
//
// Section-specific behavior (header drawer, announcement marquee, etc.) lives
// inside `{% javascript %}` tags within each section file — Shopify bundles
// those into a single file automatically.
//
// This file is reserved for cross-cutting concerns:
//   - JS-enabled class swap (lets CSS hide enhanced-only UI when JS is off)
//   - Global escape-key handling for drawers and modals
// ============================================================================

(function () {
  'use strict';

  // Swap `no-js` → `js` so CSS can target JS-enabled UA's.
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // Broadcast Escape so any open drawer/dialog can close itself.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.dispatchEvent(new CustomEvent('maison:escape'));
  });
})();
